/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".login-toolbar[_ngcontent-%COMP%]{margin:0}.alert[_ngcontent-%COMP%]{color:red}"];
export { styles as styles };
